import { fetchUserSettings } from "@/features/user-settings/infrastructure/api/userSettingsApi";
import type { UserSettingsSnapshot } from "@/features/user-settings/domain/entities/UserSettings";

export const resolveLoginSettingsAfterLogin = async (
  token: string,
  fallback?: UserSettingsSnapshot,
): Promise<UserSettingsSnapshot> => {
  try {
    const settings = await fetchUserSettings(token);
    return {
      otpPreference: settings.otpPreference ?? fallback?.otpPreference,
      isTotpEnabled: settings.isTotpEnabled || (fallback?.isTotpEnabled ?? false),
    };
  } catch {
    return fallback ?? { isTotpEnabled: false };
  }
};
